var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"返回","left-arrow":""},on:{"click-left":function($event){return _vm.$router.back()}}}),_c('router-view',{style:(`height: ${_vm.clientHeight - 46}px;`)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }